import { render, staticRenderFns } from "./imgSlider.vue?vue&type=template&id=26ac98e0&scoped=true&"
import script from "./imgSlider.vue?vue&type=script&lang=js&"
export * from "./imgSlider.vue?vue&type=script&lang=js&"
import style0 from "./imgSlider.vue?vue&type=style&index=0&id=26ac98e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ac98e0",
  null
  
)

export default component.exports